module.exports = __webpack_public_path__ + "static/media/Illus-Credit_2.bfa33718.png";